import React from 'react';
import { useTranslation } from 'react-i18next';

const CustomProductBadge: React.FC = () => {
  const { t } = useTranslation('client');
  return (
    <div className="h-[18px] px-2 bg-[#B8093B] rounded-full inline-flex justify-center items-center gap-1">
      <div className="justify-center text-white text-[13px] font-medium font-['Borna'] leading-[13px]">{t('productDetail.ownProduct')}</div>
    </div>
  );
};

export default CustomProductBadge;
